import React from 'react';
import Icon from '@atlaskit/icon';
import AssetsGraph from '@atlaskit/icon-lab/core/assets-graph';
import { ObjectGraphGlyph } from '@atlassian/jira-servicedesk-insight-glyphs/src/index.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

export type Props = {
	label: string;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) =>
	isVisualRefreshEnabled() ? (
		<AssetsGraph label={props.label} />
	) : (
		<Icon glyph={ObjectGraphGlyph} label={props.label} />
	);
